import BreadCrumbs from 'components/breadcrumbs'
import TableDashboard from '../dashboard/TableDashboard'

const ListTransactions = () => {
  return (
    <div className="w-100 px-3">
      <div className="d-flex align-items-start gap-2 pt-3">
        <BreadCrumbs breadCrumbActive={'Daftar Transaksi'} />
      </div>
      <div className="d-flex flex-column gap-2 mb-2">
        <TableDashboard title={'Daftar Transaksi'} isList />
      </div>
    </div>
  )
}

export default ListTransactions
